import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {themedark, themelight} from '../Redux/Actions/theme';

const Settings = () => {
  const {colors, mode} = useSelector((state) => state.theme);
  const dispatch = useDispatch();
  return (
    <div
    style={{
      color: colors.primary,
      backgroundColor: colors.white,
    }}>
        <label htmlFor="red-toggle"
        className="inline-flex relative items-center mr-5 cursor-pointer">
          <input type="checkbox" value=""
          id="red-toggle" className="sr-only peer" checked={mode=='dark'}
          onClick={() => {
            mode=='light'?dispatch(themedark()): dispatch(themelight());
          }}/>
          <div className="w-11 h-6 bg-gray-200 rounded-full
          peer peer-focus:ring-4 peer-focus:ring-red-300
          dark:peer-focus:ring-red-800 dark:bg-gray-700
          peer-checked:after:translate-x-full peer-checked:after:border-white
          after:content-[''] after:absolute after:top-0.5 after:left-[2px]
          after:bg-white after:border-gray-300 after:border after:rounded-full
          after:h-5 after:w-5 after:transition-all dark:border-gray-600
          peer-checked:bg-red-600"></div>
          <span className="ml-3 text-sm font-medium">Theme Dark</span>
        </label>
    </div>
  );
};

export default Settings;
